import { render } from "./OneOnOneRoleDropdown.vue?vue&type=template&id=5f561e66"
import script from "./OneOnOneRoleDropdown.vue?vue&type=script&lang=js"
export * from "./OneOnOneRoleDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script